<template>
  <div class="slider-container">
    <label :for="sliderName" class="before">{{minName}}</label>
    <div :id="sliderName" class="slider">
      <div class="slider-range" :style="{ left: rangeOffset(), width: rangeWidth()}"></div>
      <div class="pointer" :style="{ left: pointerOffset()}"><span>{{recipeValue}}</span></div>
    </div>
    <label :for="sliderName" class="after">{{maxName}}</label>
    <label :for="sliderName" class="below">
      <span>{{[rangeMin, rangeMax].join(' - ')}} {{rangeName}}</span>
    </label>
  </div>
</template>

<script>
    export default {
        name: 'slider',
        props: {
            sliderName: String,
            recipeValue: Number,
            minName: String,
            maxName: String,
            rangeName: String,
            min: Number,
            max: Number,
            rangeMin: Number,
            rangeMax: Number
        },
        components: {},
        data() { return {}; },

        methods: {
            rangeWidth() {
                let rangeWidth = this.rangeMax - this.rangeMin;
                let totalPoints = this.max - this.min;
                let width = rangeWidth / totalPoints * 100;

                return width + "%";
            },
            rangeOffset() {
                let totalPoints = this.max - this.min;
                let offset = (this.rangeMin - this.min) / totalPoints * 100;

                return offset + "%";
            },
            pointerOffset() {
                let safeValue;
                let totalPoints = this.max - this.min;

                if (this.recipeValue < this.min) {
                    safeValue = this.min;
                } else if (this.recipeValue > this.max) {
                    safeValue = this.max;
                } else {
                    safeValue = this.recipeValue;
                }
                let offset =  (safeValue - this.min) / totalPoints * 100;

                return offset + "%";
            }
        },
        beforeMount() {
        },
    };
</script>

<style scoped lang="scss">
  @import "../../assets/scss/_variablesx.scss";

  .slider-container {
    position: relative;
    margin: 20px 40px;

    .slider {
      display: inline-block;
      width: 100%;
      margin: 0;
      height: 10px;
      border: 0;
      border-radius: 4px;
      box-shadow: 1px 0 2px $gray-700;
      position: relative;

      .pointer {
        transition: all 200ms;
        width: 30px;
        margin-left: -15px;
        white-space: nowrap;
        display: block;
        top: -25px;
        font-size: 0.7em;
        position: absolute;

        & > span {
          display: block;
          width: 100%;
          text-align: center;
          opacity: 0;
        }
        &:hover > span {
          opacity: 1;
        }

        &::before {
          content: " ";
          top: 13px;
          width: 0;
          height: 0;
          margin-left: 8px;
          border-style: solid;
          border-width: 10px 7.5px 0 7.5px;
          border-color: $orange transparent transparent transparent;
          position: absolute;
        }
      }
    }

    .slider-range {
      top: -21px;
      font-size: 35px;
      position: relative;
      font-weight: 400;
      text-shadow: 1px 1px 2px $gray-700;
      background: 0 0;
      min-width: 35px;
      transition: all 200ms;

      &::before,
      &::after {
        color: $white;
        position: absolute;
        font-size: 60%;
        margin-top: 9px;
      }

      &::before {
        content: "[";
        margin-left: -4px;
        left: 0;
      }

      &::after {
        content: "]";
        margin-right: -3px;
        right: 0;
      }
    }

    label {
      width: 34px;
      position: absolute;

      &.before {
        left: -40px;
        text-align: right;
      }

      &.after {
        right: -40px;
        text-align: left;
      }

      &.below {
        font-size: .7em;
        position: static;
        width: 100%;
        text-align: center;
      }
    }
  }
</style>
